// extracted by mini-css-extract-plugin
export default {"text":"DateTemplate_text__E7qfd","addText":"DateTemplate_addText__r-Ede","icon":"DateTemplate_icon__i8oUA","iconWithValue":"DateTemplate_iconWithValue__JMhNz"};